import React, {useEffect, useState} from "react";
import {SDrawerOrModal} from "shj-components";
import {CallBox} from "@/pages/callTool/intelligentOutboundCall/components/Info/Left/CallBox.tsx";
import {Col, Row} from "antd";
import {useAtom} from "jotai";

import {AddForm} from "@/pages/salesWorkbench/workbenchList/components/SeatAddClueModal/addForm.tsx";
import {callDataAtom} from "@/pages/callTool/intelligentOutboundCall/components/Info/store";
import {SOFT_PHONE_EVENTS, triggerEvent, useSoftPhoneStore} from "@shj/use-soft-phone";

export const SeatAddClueModal = (props) => {
  const {open, onClose, reload} = props;
  const [callData, setCallData] = useAtom(callDataAtom)
  const updateSoftPhoneAttr = useSoftPhoneStore(state => state?.updateSoftPhoneAttr)

  useEffect(() => {
    if(open) {
      setCallData((callData) => ({...callData, phone: ''}))
    }
    return () => {
      updateSoftPhoneAttr('extenType', "gateway")
      triggerEvent(SOFT_PHONE_EVENTS.SWITCH_EXTEN_TYPE, { extenType: "gateway" })
    }
  }, [open]);

  return <SDrawerOrModal
      title={'云客服新增'}
      open={open}
      width={1050}
      onCancel={() => {
        onClose()
        reload()
      }}
      // onOk={onSubmit}
      antdProps={{footer: null}}
  >
    <Row gutter={1} style={{backgroundColor: '#eeeeee', height: '100%'}}>
      <Col span={8}>
        <div style={{backgroundColor: '#fff', height: '100%', paddingRight: 20}}>
          <CallBox/>
        </div>
      </Col>
      <Col span={16}>
        <div style={{backgroundColor: '#fff', height: '100%'}}>
          <AddForm/>
        </div>
      </Col>
    </Row>
  </SDrawerOrModal>;
}